var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var GreenCheck = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 26 26", fillRule: "evenodd", className: "check-mark" }, props),
        React.createElement("circle", { fill: color, cx: "13", cy: "13", r: "13" }),
        React.createElement("path", { d: "M9.387 19.399c.4.394.927.601 1.496.601s1.095-.228 1.496-.601l8.005-7.872a2.04 2.04 0 0 0 0-2.921c-.822-.808-2.149-.808-2.97 0l-6.552 6.401-2.275-2.237c-.822-.808-2.149-.808-2.97 0a2.04 2.04 0 0 0 0 2.921l3.771 3.708z", fill: "#fff", fillRule: "nonzero" })));
};
GreenCheck.defaultProps = {
    color: '#96c8be',
};
export default GreenCheck;
//# sourceMappingURL=GreenCheck.js.map